<template>
  <div id="image-slider">
    <div class="carousel">
      <img class="package-image" :src="imagesList[selectedimageURLindex]">
      <div class="offer-box" v-if="discount">
        {{discount}}% off
      </div>

      <a class="fav-icon" @click="addOrRemoveShortList(pkg)">
        <div class="icon-compare-box" :title="isShortListed(pkg.packageId) ? 'Remove from compare' : 'Add to compare'" :class="{'selected': isShortListed(pkg.packageId)}">
          <!-- <i class="icon icon-compare"></i> -->
          <img :src="isShortListed(pkg.packageId) ? require('../../static/Images/compare-selected.png') : require('../../static/Images/compare.png')" class="filter-icon" alt="compare">

        </div>
      </a>
      <transition name="fade" v-on:after-enter="errorAfterEnter">
        <div v-if="displayShortListError">
          <i class="ico ico-left-shadow-caret arrow-left"></i>
          <div class="message popup-info">
            You already selected 3 packages.
          </div>
        </div>
      </transition>

      <div class="magnifier bg-white" v-if="lodingMedia">
        <a href="#">
          <i class="icon icon-search icon-large-loader"></i>
        </a>
      </div>
      <div class="magnifier" v-else>
        <a @click="openGallery">
          <i class="icon icon-search"></i>
        </a>
      </div>

      <a class="next" v-if="selectedimageURLindex < imagesList.length - 1" @click="nextImage">
        <i class="icon icon-right-open"></i>
      </a>
      <a class="prev" v-if="selectedimageURLindex > 0" @click="prevImage">
        <i class="icon icon-left-open"></i>
      </a>

    </div>
  </div>
</template>

<script>
import cookie from '../common/cookie'
// import axios from 'axios'
// import urls from '../common/URLStore'
import preload from '../common/preload'

export default {
  data: function() {
    return {
      lodingMedia: false,
      selectedimageURLindex: 0,
      displayShortListError: false
    }
  },
  mixins: [cookie, preload],
  props: {
    imagesList: {
      type: Array,
      required: true,
      default: function() {
        return []
      }
    },
    discount: {
      type: Number,
      required: false,
      default: function() {
        return 0
      }
    },
    pkg: {
      type: Object,
      required: false,
      default: function() {
        return 0
      }
    },
    packageCompareToggled: {
      type: Number
    }
  },
  watch: {
    packageCompareToggled: function() {
      this.$forceUpdate()
    }
  },
  methods: {
    prevImage: function() {
      this.selectedimageURLindex--
    },
    nextImage: function() {
      this.selectedimageURLindex++
    },
    showShortListError: function() {
      this.displayShortListError = true
    },
    errorAfterEnter: function() {
      this.displayShortListError = false
    },
    // addOrRemoveShortList: function(pkg) {
    //   if (!this.isShortListed(pkg.packageId)) {
    //     var shortListed = this.shortListPackage(pkg)
    //     if (!shortListed) {
    //       this.showShortListError()
    //     }
    //   } else {
    //     this.removeFromShortList(pkg.packageId)
    //   }
    //   this.$forceUpdate()
    //   this.$emit('packageCompareToggled')
    // },
    openGallery: function() {
      this.lodingMedia = true
      this.getPacakgeMedia(this.pkg.packageId)
        .then(resp => {
          this.lodingMedia = false
          this.$emit('openGallery', resp)
        })
        .catch(() => {
          this.lodingMedia = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#image-slider {
  img {
    height: 100%;
    width: 100%;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    object-fit: cover;
    &.filter-icon {
      height: 19px;
      width: initial;
      position: relative;
      top: 7px;
      left: 1px;
    }
  }
}

.popup-info {
  box-shadow: 4px 4px 6px 0px rgba(0, 0, 0, 0.4);
  position: absolute;
  top: 12px;
  left: 232px;
  width: 300px;
  padding: 10px;
  display: block;
  z-index: 1;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  color: white;
}
.arrow-left {
  position: absolute;
  top: 22px;
  left: 225px;
  width: 0px;
  height: 0px;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-right: 7px solid rgba(0, 0, 0, 0.7);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: all 0.5s ease;
}

.package-image {
  border-right: 1px solid #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// src/components/carousel.vue